import { render, staticRenderFns } from "./release-component.vue?vue&type=template&id=eaaa48c4&scoped=true&"
import script from "./release-component.vue?vue&type=script&lang=ts&"
export * from "./release-component.vue?vue&type=script&lang=ts&"
import style0 from "./release-component.vue?vue&type=style&index=0&id=eaaa48c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaaa48c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
